export default __webpack_public_path__ + "static/budgie-f4c7a60cd9fb203f620467d0da4b3ccd.webp";